await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-js-components-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export default {
	address: {
		icon: 'geolocation',
		title: Liferay.Language.get('address'),
	},
	checkbox: {
		icon: 'check',
		title: Liferay.Language.get('boolean'),
	},
	checkbox_multiple: {
		icon: 'check-circle',
		title: Liferay.Language.get('checkbox-multiple-field-type-label'),
	},
	city: {
		icon: 'geolocation',
		title: Liferay.Language.get('city'),
	},

	color: {
		icon: 'color-picker',
		title: Liferay.Language.get('color-field-type-label'),
	},
	country: {
		icon: 'geolocation',
		title: Liferay.Language.get('country'),
	},
	date: {
		icon: 'calendar',
		title: Liferay.Language.get('date-field-type-label'),
	},
	date_time: {
		icon: 'date-time',
		title: Liferay.Language.get('date-and-time'),
	},
	document_library: {
		icon: 'upload',
		title: Liferay.Language.get('upload'),
	},
	grid: {
		icon: 'table2',
		title: Liferay.Language.get('grid-field-type-label'),
	},
	image: {
		icon: 'picture',
		title: Liferay.Language.get('image'),
	},
	numeric: {
		icon: 'integer',
		title: Liferay.Language.get('numeric-field-type-label'),
	},
	['object-relationship']: {
		icon: 'relationship',
		title: Liferay.Language.get('object-relationship-field-type-label'),
	},
	place: {
		icon: 'geolocation',
		title: Liferay.Language.get('search-location-field-type-label'),
	},
	['postal-code']: {
		icon: 'geolocation',
		title: Liferay.Language.get('postal-code'),
	},
	radio: {
		icon: 'radio-button',
		title: Liferay.Language.get('radio-field-type-label'),
	},
	select: {
		icon: 'list',
		title: Liferay.Language.get('select-field-type-label'),
	},
	state: {
		icon: 'geolocation',
		title: Liferay.Language.get('state'),
	},
	text: {
		icon: 'text',
		title: Liferay.Language.get('text-field-type-label'),
	},
};
